"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profitability = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../../../utils/classFunctions");
const roundMoney_1 = require("../../../../../../utils/roundMoney");
const MultiLanguage_1 = require("../../../../../MultiLanguage");
const Sub_1 = require("../../../../../Page/Title/Sub");
const tariffGroupMapper_1 = require("../../../../../TariffsTable/tariffGroupMapper");
const FlightInfoTable_1 = require("../FlightInfoTable");
require("./index.scss");
const className = 'flight-list-info-turnover';
const columnMapToModifier = {
    turnover: 'green',
    allotmentTurnover: 'green',
    cost: 'red',
    margin: 'red',
    total: undefined,
};
const createTableColumns = (args) => {
    const { economyTariffGroupName, businessTariffGroupName, locale, flightTurnoverInfo } = args;
    return [
        {
            Header: '',
            id: 'user',
            disableSortBy: true,
            Cell: ({ row }) => {
                if (row.original.isTotal)
                    return '';
                return row.original.label;
            },
        },
        {
            Header: (react_1.default.createElement(MultiLanguage_1.MultiLanguage, { value: economyTariffGroupName })),
            id: 'economy',
            disableSortBy: true,
            Cell: ({ row }) => {
                if (row.original.isTotal)
                    return '';
                return (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(className, columnMapToModifier[row.original.type]) }, (0, roundMoney_1.localizeMoney)(row.original.economy, locale, 'Flight/List/Info/Profitability/economy')));
            },
        },
        {
            Header: (react_1.default.createElement(MultiLanguage_1.MultiLanguage, { value: businessTariffGroupName })),
            id: 'business',
            disableSortBy: true,
            Cell: ({ row }) => {
                if (row.original.isTotal)
                    return (react_1.default.createElement("div", { className: `${className}__benefit-title` },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:Benefit', defaultMessage: 'Benefit' })));
                return (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(className, columnMapToModifier[row.original.type]) }, (0, roundMoney_1.localizeMoney)(row.original.business, locale, 'Flight/List/Info/Profitability/business')));
            },
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:TotalTurnover', defaultMessage: 'Total' })),
            id: 'total',
            disableSortBy: true,
            Cell: ({ row }) => {
                if (row.original.isTotal) {
                    const isPositive = flightTurnoverInfo.benefit !== undefined && flightTurnoverInfo.benefit >= 0;
                    return (react_1.default.createElement("div", { className: `${className}__benefit-value ${isPositive ? 'positive' : 'negative'}` }, (0, roundMoney_1.localizeMoney)(row.original.total, locale, 'Flight/List/Info/Profitability/benefit')));
                }
                return (0, roundMoney_1.localizeMoney)(row.original.total, locale, 'Flight/List/Info/Profitability/total');
            },
        },
    ];
};
const Profitability = (props) => {
    const { flightTurnoverInfo, economyTariffGroup, businessTariffGroup, } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const tableColumns = (0, react_1.useMemo)(() => createTableColumns({
        flightTurnoverInfo,
        economyTariffGroupName: economyTariffGroup.name,
        businessTariffGroupName: businessTariffGroup.name,
        locale,
    }), [economyTariffGroup, businessTariffGroup, flightTurnoverInfo, locale]);
    const convertTotalByTariffGroupToTableData = (tariffGroup) => {
        var _a, _b;
        return ({
            economy: (_a = tariffGroup.find(x => (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(x.tariffGroup.id) === 'economy')) === null || _a === void 0 ? void 0 : _a.total,
            business: (_b = tariffGroup.find(x => (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(x.tariffGroup.id) === 'business')) === null || _b === void 0 ? void 0 : _b.total,
            total: tariffGroup.reduce((total, totalByTariffGroup) => total + totalByTariffGroup.total, 0),
        });
    };
    const profitabilityData = [
        {
            type: 'turnover',
            label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:Turnover', defaultMessage: 'Turnover' })),
            ...convertTotalByTariffGroupToTableData(flightTurnoverInfo.turnoverByTariffGroup),
        },
        {
            type: 'allotmentTurnover',
            label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:AllotmentTurnover', defaultMessage: 'Allotment Turnover' })),
            ...convertTotalByTariffGroupToTableData(flightTurnoverInfo.allotmentTurnoverByTariffGroup),
        },
        {
            type: 'cost',
            label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:Cost', defaultMessage: 'Cost' })),
            ...convertTotalByTariffGroupToTableData(flightTurnoverInfo.costByTariffGroup),
        },
        {
            type: 'margin',
            label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:Margin', defaultMessage: 'Margin' })),
            ...convertTotalByTariffGroupToTableData(flightTurnoverInfo.marginByTariffGroup),
        },
        {
            type: 'total',
            label: '',
            isTotal: true,
            total: flightTurnoverInfo.benefit,
        },
    ];
    if (!flightTurnoverInfo)
        return null;
    if (!(economyTariffGroup === null || economyTariffGroup === void 0 ? void 0 : economyTariffGroup.id) || !(businessTariffGroup === null || businessTariffGroup === void 0 ? void 0 : businessTariffGroup.id)) {
        console.error('Tariff group not found');
        return null;
    }
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'dollar-circle', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:Profitability', defaultMessage: 'Profitability' }), modificators: 'margin-bottom-sm' }),
        react_1.default.createElement(FlightInfoTable_1.FlightInfoTable, { columns: tableColumns, data: profitabilityData })));
};
exports.Profitability = Profitability;
//# sourceMappingURL=index.js.map